const chartColor = [
  "#ff000050",
  "#f000ff50",
  "#00ffab50",
  "#17295450",
  "#2155cd50",
  "#ff715c50",
  "#b8f1b050",
  "#4f8a9050",
  "#ff000050",
  "#f000ff50",
  "#00ffab50",
  "#17295450",
];

export default chartColor;
